import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PSTasacionModel } from '../models/ps-tasacion-model';

@Injectable({
  providedIn: 'root'
})
export class PsTasacionService {

  myAppUrl: string;

  constructor(private _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.myAppUrl = baseUrl;
  }

  get(id: number) {
    return this._http.get(`${ this.myAppUrl }api/PS_Tasacion/${id}`);
  }

  getFromTasacion(id: number) {
    return this._http.get(`${ this.myAppUrl }api/PS_Tasacion/Tasacion/${id}`);
  }

  post(item: PSTasacionModel) {
    console.log(item)
    return this._http.post<PSTasacionModel>(`${ this.myAppUrl }api/PS_Tasacion`, item);
  }

  delete(is: number) {
    return this._http.delete<PSTasacionModel>(`${this.myAppUrl}api/PS_Tasacion/${is}`);
  }

}
